module.exports = __webpack_public_path__ + "static/elsevier_logo-8ff09706656749fafc45d9f876bb3460.png";